import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'ngx-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AlertModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { title: string; message: string; hideCancel?: boolean },
    private dialogRef: MatDialogRef<AlertModalComponent>
  ) {}

  accept(): void {
    this.dialogRef.close(true);
  }

  close(): void {
    this.dialogRef.close();
  }
}
